<template>
  <div class="eighthPage">
    <el-row :gutter="100" justify="center" align="middle" class="row">
      <el-col :span="12" class="col">
        <div class="left">
          <div class="one">
            <span>
              基于服务各类企业的大量实践，X Learning在沉浸式学习领域，经过长时间的研发以及产品迭代，开发出
            </span>
            <span class="book">
              《单车工坊 - 团队动力解码®》、《星际争霸 - 战略解码123®》、《对话对画 -
              领导力觉察®》、《巨幕演讲®》 、《黑暗足球 - 变革对撞®》
            </span>
            <span>
              等一系列品牌课程。
            </span>
          </div>
          <span class="two">
            研发出多项广受客户好评的沉浸式学习工具，如团队互动讨论工具 - 筹牌TM，大复翁TM，四扇门学习法、团队动力拼图TM、情绪画布TM 、组织动力画布TM等，并形成了独特的学习方法论。
          </span>
          <el-row :gutter="20" class="three">
            <el-col :span="12">
              <img src="/static/imgs/eighthPage/1.png" />
            </el-col>
            <el-col :span="12">
              <img src="/static/imgs/eighthPage/2.png" />
            </el-col>
          </el-row>
          <span class="four">
            版权课程证书
          </span>
        </div>
      </el-col>

      <el-col :span="12" class="col">
        <div class="right">
          <el-row class="one" :gutter="20">
            <el-col :span="11">
              <img src="/static/imgs/eighthPage/3.png" />
            </el-col>
            <el-col :span="13">
              <img src="/static/imgs/eighthPage/4.png" />
            </el-col>
          </el-row>
          <span class="two">
            《沉浸式学习》
          </span>
          <span class="three">
            作为国内首家提出沉浸式学习理论的培训机构，X
            Learning（无界学习）于2020年出版了《沉浸式学习》一书，该书基于自2016年以来，服务200多家企业近千场专业沉浸式培训与咨询服务的实践经验，提出了沉浸式学习理论，并将该理论应用于人才发展、团队绩效、组织变革、战略实施、企业文化落地、管培生等企业组织发展项目的实践应用场景。
          </span>
        </div>
      </el-col>
    </el-row>

  </div>

</template>

<script>
export default {
  name: "eighthPage",
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.eighthPage {
  margin: 0 0 0px 0;
  background-color: whitesmoke;
  padding: 100px 50px;
}

.left {
  text-align: left;
  .one {
    font-size: 15px;
    font-family: '';
    color: #001f57;
    .book {
      font-style: oblique;
      font-size: 10px;
    }
  }
  .two {
    display: block;
    margin-top: 30px;
    color: #001f57;
    font-family: '';
    font-size: 15px;
  }
  .three {
    margin-top: 30px;
    img {
      width: 100%;
    }
  }
  .four {
    margin-top: 10px;
    display: block;
    text-align: center;
    font-size: 10px;
    color: #909399;
  }
}

.right {
  .one {
    display: flex;
    justify-content: end;
    align-items: flex-end;
    img {
      width: 100%;
    }
  }
  .two {
    margin-top: 10px;
     display: block;
    text-align: center;
    font-size: 10px;
    color: #909399;
  }
  .three {
    display: block;
    margin-top: 30px;
    font-family: '楷体';
    font-size: 15px;
    color: #001f57;
    text-align: left;
    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/eighthPage.vue